<template>
    <div>
        <page-title>插件版本信息</page-title>
        <page-body>
            <div style="margin-bottom: 20px;" flex="cross:center" v-if="plugin">
                <div style="margin-right: 10px;">
                    <img :src="plugin.pic_url"
                         style="width: 40px;height: 40px;border-radius: 3px; display: block;background: #3a8ee6;">
                </div>
                <div style="line-height: 1.45;height: 40px;" flex="dir:top box:last">
                    <div>{{plugin.display_name}}</div>
                    <div style="font-size: 12px;color: #909399;">{{plugin.name}}</div>
                </div>
            </div>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="版本号" prop="version">
                    <el-input v-model="form.version" placeholder="插件版本号，如1.2.1"/>
                </el-form-item>
                <el-form-item label="更新说明" prop="content">
                    <el-input v-model="form.content" placeholder="" type="textarea" :rows="5"/>
                </el-form-item>
                <el-form-item label="插件后端代码包" prop="src_file">
                    <uploader v-model="form.src_file"></uploader>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '新增'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>

    </div>
</template>

<script>
import axios from '@/axios'
import baseUrl from '@/base-url'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import uploader from '@/components/Uploader'
export default {
    components: {
        quillEditor,
        uploader
    },
    data() {
        const validateVersion = (rule, value, callback) => {
            if (!this.packageVersion || !value) {
                return callback()
            }
            if (this.packageVersion !== value) {
                return callback(new Error('版本号与代码包版本不符合，代码包版本号' + this.packageVersion))
            }
            return callback()
        }
        return {
            loading: false,
            btnLoading: false,
            detail: null,
            packageVersion: null,
            rules: {
                version: [
                    {required: true, message: '请填写版本号。'},
                    {validator: validateVersion}
                ],
                content: [
                    {required: true, message: '请填写更新内容。'}
                ],
                src_file: [
                    {required: true, message: '请上传后端代码包。'}
                ]
            },
            plugin: null,
            form: {
                id: null,
                plugin_id: null,
                version: '',
                content: '',
                src_file: '',
                wxapp_file: ''
            },
            masterVersionData: null,
            LoadingMasterVersionData: false,
            showMasterVersionData: false
        }
    },
    created() {
        this.form.id = this.$route.query.id || null
        this.form.plugin_id = this.$route.query.plugin_id || null
        this.loadData()
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/plugin-version/detail',
                params: {
                    id: this.form.id,
                    plugin_id: this.form.plugin_id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.plugin = e.data.data.plugin
                    if (e.data.data.form) {
                        this.form = e.data.data.form
                    }
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        onSrcUploadSuccess(response) {
            this.packageVersion = response.data.validate.version
            if (!this.form.version) {
                this.form.version = this.packageVersion
            }
            if (!this.form.content) {
                this.form.content = this.packageVersion
            }
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: 'admin/plugin-version/edit',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.push('/dashboard/admin/plugin/version?plugin_id=' + this.form.plugin_id)
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        },
        loadMasterVersionData() {
            if (this.masterVersionData) {
                this.showMasterVersionData = true
                return
            }
            this.LoadingMasterVersionData = true
            axios({
                url: 'admin/plugin/master-version-data',
                params: {
                    name: this.plugin.name
                }
            }).then(e => {
                this.LoadingMasterVersionData = false
                this.showMasterVersionData = true
                if (e.data.code === 0) {
                    this.masterVersionData = e.data.data
                }
            }).catch(e => {
                this.LoadingMasterVersionData = false
            })
        },
        useMasterVersionData(index) {
            this.form.version = this.masterVersionData.list[index].version
            this.form.src_file = this.masterVersionData.list[index].src_file
            this.form.content = this.masterVersionData.list[index].content
            this.showMasterVersionData = false
        }
    }
}
</script>
<style lang="scss" scoped>
    .ellipsis-1 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .master-versions {
        .item {
            border: 1px solid #e5e5e5;
            padding: 8px 10px;
            border-bottom-width: 0;

            > div:last-child {
                padding-left: 10px;
            }
        }

        .item:last-child {
            border-bottom-width: 1px;
        }
    }
</style>
